<template>
    <div>
        <div class="card ">
              <div class="card-header">
                <div class="row">
                   <div class="col-9">
                  <h4 class="card-title"> ÖĞRENCİLER  </h4>
                </div>
                <div class="col">
                  <button @click="goToNew" class="btn btn-primary btn-round">YENİ KAYIT</button>
                </div>
                </div>    
                <div class="row">
                  <div class="col-3">
                     <input  v-model="text" class="form-control" type="search" name="" id="">
                  </div>
                  </div>   
              </div>
              <div class="card-body tablo">
                <div class="table-responsive">
                  <table class="table table-striped table-hover">
                    <thead class=" text-primary">
                      <tr>
                      <th>
                        AD SOYAD
                      </th>
                      <th>
                        ÖĞRENCİ NO
                      </th>
                      <th>
                        FAKÜLTE-BÖLÜM
                      </th>
                      <th>
                        BULUNDUĞU FİRMA
                      </th>
                      <th>
                        
                      </th>
                    </tr></thead>
                    <tbody>
                      <tr  v-for="(ogrenci, index) in arama" :key="ogrenci.id" >
                        <td>
                          {{ogrenci.adi}}
                        </td>
                        <td>
                          {{ogrenci.tc}}
                        </td>
                        <td>
                          {{ogrenci.fakulte}} / {{ogrenci.bolum}}
                        </td>
                        <td>
                         FİRMA ADI
                        </td>
                        <td>
                         <button @click="selectedStudent(index)" class="btn btn-success btn-round btn-sm">G</button>
                         <button class="btn btn-warning btn-round btn-sm">D</button>
                         <button @click="deleteStudent([ogrenci.key,index])" class="btn btn-danger btn-round btn-sm">-</button>
                        </td>
                      </tr>

                      
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
    </div>
</template>
<script>
import { mapGetters} from "vuex";

export default {
   data(){
    return{
      text : ""
    }
  },
  computed : {
      ...mapGetters(["getStudents"]),
        arama(){
        return this.getStudents.filter((element) => {
          if(this.text == ""){
            return element
          }else {
            return element.adi.match(this.text);
          }
        })
      },
    },
    methods : {
      goToNew(){
        this.$router.push("/studentnew")
      },
      deleteStudent(i){
        console.log(i)
        var r = confirm("ÖĞRENCİ KAYDINI SİLMEK İSTEDİĞİNİZDEN EMİN MİSİNİZ?")
        if (r == true) {
          this.$store.dispatch("deleteStudent", i)
          
        } else {
          
        }
                
      },
      selectedStudent(index){
        this.$store.commit("updateSelectedStudent",index)
        this.$router.push("/studentinfo")
      },
      
    }
}
</script>

<style >
.tablo{
  height: 40%;
}
</style>


// WEBPACK FOOTER //
// src/components/student/StudentTable.vue